import { Button, TextArea } from '@calizahq/react-components-v2'
import { Form, Formik } from 'formik'
import React from 'react'

import { AccessInstructionMutations } from '@/graphql/mutations/accessInstructions.mutations'
import { useGraphqlMutation } from '@/hooks/useGraphql'
import { AccessInstruction } from '@/types/Homes'

type Props = {
  accessInstruction: AccessInstruction
  closeModal: () => void
  refetchOnSuccess?(): void
}

export const UpdateInstructionForm = ({ accessInstruction, refetchOnSuccess, closeModal }: Props) => {
  const { name, instruction = '', id, accessibleId } = accessInstruction
  const { mutate, isPending: isLoading } = useGraphqlMutation(AccessInstructionMutations.updateAccessInstruction(), {
    onSuccess: () => {
      refetchOnSuccess && refetchOnSuccess()
      closeModal()
    },
  })

  const handleSubmit = ({ instruction = '' }: FormValues) => {
    if (instruction.length > 0) {
      mutate({ accessInstruction: { instruction, id, accessibleId } })
    }
  }

  return (
    <Formik initialValues={{ instruction }} onSubmit={handleSubmit}>
      <Form className="flex w-full flex-row flex-wrap px-4 md:px-8">
        <TextArea className="mb-4 w-full" label={name} name="instruction" />
        <Button className=" w-full bg-text-semantic-success" disabled={isLoading} isLoading={isLoading} type="submit">
          Submit
        </Button>
      </Form>
    </Formik>
  )
}

type FormValues = {
  instruction: string
}
